import tenants from '@config/tenants.json'

/**
 * Single source of truth for Auth0 organization IDs.
 *
 * The raw JSON lives in the repo-root `config/tenants.json` file, which is also
 * consumed by the backend. This module is the only place that imports it; every
 * other frontend module must reference org IDs through `tenantOrgIds`.
 */
export const tenantOrgIds = tenants.tenants

export type TenantKey = keyof typeof tenantOrgIds
